import React from 'react'
import { ActionButton } from './ActionButton'

function RevertAccentButton(props) {
  return <ActionButton backgroundColor="#d0021b" iconFill="#ffffff" iconType="iconGoBackBold" {...props} />
}

export { RevertAccentButton }
